import { createAction } from '@reduxjs/toolkit';

export const highlightUpdateId = createAction('highlight/updateId');
export const highlightUpdateUID = createAction('highlight/updateUID');
export const highlightUpdateSID = createAction('highlight/updateSID');
export const highlightUpdateIsAdded = createAction('highlight/updateIsAdded');
export const highlightUpdateIsActive = createAction('highlight/updateIsActive');

export const highlightStore = createAction('highlight/store');
export const highlightClear = createAction('highlight/clear');

export const highlightUpdateRequesting = createAction('highlight/updateRequesting');
export const highlightUpdateRequest = createAction('highlight/updateRequest');
export const highlightUpdateError = createAction('highlight/updateError');
export const highlightUpdateStore = createAction('highlight/updateStore');

export const highlightUpdateItems = createAction('highlight/updateItems');
export const highlightUpdateView = createAction('highlight/updateView');

export const highlightUpdateHeadingTitle = createAction('highlight/updateHeadingTitle');
export const highlightUpdateHeadingDescription = createAction('highlight/updateHeadingDescription');
export const highlightUpdateHeadingTextAlign = createAction('highlight/updateHeadingTextAlign');
export const highlightUpdateHeadingImage = createAction('highlight/updateHeadingImage');
export const highlightUpdateHeadingDivider = createAction('highlight/updateHeadingDivider');

export const highlightUpdateSectionIsBackground = createAction('highlight/updateSectionIsBackground');
export const highlightUpdateSectionTextColor = createAction('highlight/updateSectionTextColor');
export const highlightUpdateSectionBackgroundColor = createAction('highlight/updateSectionBackgroundColor');
export const highlightUpdateSectionOpacity = createAction('highlight/updateSectionOpacity');
export const highlightUpdateSectionIsFullWidth = createAction('highlight/updateSectionIsFullWidth');
export const highlightUpdateSectionShadow = createAction('highlight/updateSectionShadow');
export const highlightUpdateSectionShadowColor = createAction('highlight/updateSectionShadowColor');
export const highlightUpdateSectionPadding = createAction('highlight/updateSectionPadding');
export const highlightUpdateSectionMargin = createAction('highlight/updateSectionMargin');
export const highlightUpdateSectionBackgroundType = createAction('highlight/updateSectionBackgroundType');
export const highlightUpdateSectionBackgroundImage = createAction('highlight/updateSectionBackgroundImage');
export const highlightUpdateSectionGradientColor1 = createAction('highlight/updateSectionGradientColor1');
export const highlightUpdateSectionGradientColor2 = createAction('highlight/updateSectionGradientColor2');
export const highlightUpdateSectionGradientDirection = createAction('highlight/updateSectionGradientDirection');
export const highlightUpdateSectionGradientOffset = createAction('highlight/updateSectionGradientOffset');
export const highlightUpdateSectionBorder = createAction('highlight/updateSectionBorder');
export const highlightUpdateSectionBorderColor = createAction('highlight/updateSectionBorderColor');
export const highlightUpdateSectionShadowBorderColor = createAction('highlight/updateSectionShadowBorderColor');
export const highlightUpdateSectionShape = createAction('highlight/updateSectionShape');

export const highlightUpdateItemOpacity = createAction('highlight/updateItemOpacity');
export const highlightUpdateItemShadow = createAction('highlight/updateItemShadow');
export const highlightUpdateItemShadowColor = createAction('highlight/updateItemShadowColor');
export const highlightUpdateItemBorder = createAction('highlight/updateItemBorder');
export const highlightUpdateItemBorderColor = createAction('highlight/updateItemBorderColor');
export const highlightUpdateItemShape = createAction('highlight/updateItemShape');
